import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-guide_ic_yq",
  "use": "icon-guide_ic_yq-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-guide_ic_yq\"><g fill=\"#4fd419\"><circle cx=\"6\" cy=\"6\" opacity=\".3\" r=\"6\" /><circle cx=\"6\" cy=\"6\" r=\"3\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/guide_ic_yq.svg
// module id = naFt
// module chunks = 87